module.exports = __webpack_public_path__ + "static/media/logo.09725d1d.webp";